import { render, staticRenderFns } from "./TheHead.vue?vue&type=template&id=b1d718e8&scoped=true&"
import script from "./TheHead.vue?vue&type=script&lang=js&"
export * from "./TheHead.vue?vue&type=script&lang=js&"
import style0 from "./TheHead.vue?vue&type=style&index=0&id=b1d718e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d718e8",
  null
  
)

export default component.exports